module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-02-en.0ae45453cf9c931dee4c570d2acb064f.png";